export const loadAhaAdminEditor = async () => {
  const { default: AhaAdminEditor } = await import(
    /* webpackChunkName: "aha-admin-editor" */ 'components/aha_admin_editor/AhaAdminEditor'
  );
  return AhaAdminEditor;
};

export const loadAdminUserTable = async () => {
  const { default: AdminUserTable } = await import(
    /* webpackChunkName: "admin-user-table" */ 'components/admin_user_table'
  );
  return AdminUserTable;
};

export const loadAutomationBuilder = async () => {
  const { default: AutomationBuilder } = await import(
    /* webpackChunkName: "automation-builder" */ 'components/AutomationBuilder/AutomationBuilder'
  );
  return AutomationBuilder;
};

export const loadBubbleList = async () => {
  const { default: BubbleList } = await import(
    /* webpackChunkName: "bubble-list" */ 'components/BubbleList/BubbleList'
  );
  return BubbleList;
};

export const loadBusinessModel = async () => {
  const { default: BusinessModel } = await import(
    /* webpackChunkName: "business-model" */ 'components/business_model'
  );
  return BusinessModel;
};

export const loadCalendarReport = async () => {
  const { default: CalendarReport } = await import(
    /* webpackChunkName: "calendar-report" */ 'components/calendar_report/CalendarReport'
  );
  return CalendarReport;
};

export const loadCapacityDetails = async () => {
  const { default: CapacityDetails } = await import(
    /* webpackChunkName: "capacity-details" */ 'components/capacity_report/CapacityDetails'
  );
  return CapacityDetails;
};

export const loadCapacityEstimateEditor = async () => {
  const { default: CapacityEstimateEditor } = await import(
    /* webpackChunkName: "capacity-estimate-editor" */ 'components/capacity_estimate_editor/CapacityEstimateEditor'
  );
  return CapacityEstimateEditor;
};

export const loadCapacityScenarioArchiveCheckbox = async () => {
  const { default: CapacityScenarioArchiveCheckbox } = await import(
    /* webpackChunkName: "capacity-scenario-archive-checkbox" */ 'components/capacity_scenarios/CapacityScenarioArchiveCheckbox'
  );
  return CapacityScenarioArchiveCheckbox;
};

export const loadProjectCardLayoutEditor = async () => {
  const { default: ProjectCardLayoutEditor } = await import(
    /* webpackChunkName: "card-layout-editor" */ 'components/CardLayoutEditor/ProjectCardLayoutEditor'
  );
  return ProjectCardLayoutEditor;
};

export const loadProjectConfigurationCardLayoutEditor = async () => {
  const { default: ProjectConfigurationCardLayoutEditor } = await import(
    /* webpackChunkName: "card-layout-editor" */ 'components/CardLayoutEditor/ProjectConfigurationCardLayoutEditor'
  );
  return ProjectConfigurationCardLayoutEditor;
};

export const loadIntegrationTemplatesModal = async () => {
  const { default: IntegrationTemplatesModal } = await import(
    /* webpackChunkName: "integration-templates-modal" */ 'components/project_configuration/IntegrationTemplatesModal'
  );
  return IntegrationTemplatesModal;
};

export const loadBookmarkCardLayoutEditor = async () => {
  const { default: BookmarkCardLayoutEditor } = await import(
    /* webpackChunkName: "card-layout-editor" */ 'components/CardLayoutEditor/BookmarkCardLayoutEditor'
  );
  return BookmarkCardLayoutEditor;
};

export const loadDevelopQuickstart = async () => {
  const { default: DevelopQuickstart } = await import(
    /* webpackChunkName: "develop-quick-start" */ 'components/getting_started/develop_quickstart/DevelopQuickstart'
  );
  return DevelopQuickstart;
};

export const loadCommonGridCalculatedColumn = async () => {
  const { default: CommonGridCalculatedColumn } = await import(
    /* webpackChunkName: "common-grid-calculated-column" */ 'components/common_grid/CommonGridCalculatedColumn'
  );
  return CommonGridCalculatedColumn;
};

export const loadCommonGridCalculatedColumnFormat = async () => {
  const { default: CommonGridCalculatedColumnFormat } = await import(
    /* webpackChunkName: "common-grid-calculated-column-format" */ 'components/common_grid/CommonGridCalculatedColumnFormat'
  );
  return CommonGridCalculatedColumnFormat;
};

export const loadCommonGridNoteColumnFormat = async () => {
  const { default: CommonGridNoteColumnFormat } = await import(
    /* webpackChunkName: "common-grid-note-column-format" */ 'components/common_grid/CommonGridNoteColumnFormat'
  );
  return CommonGridNoteColumnFormat;
};

export const loadCreateHomepage = async () => {
  const { default: CreateHomepage } = await import(
    /* webpackChunkName: "create-homepage" */ 'components/create_homepage/DesktopNotes'
  );
  return CreateHomepage;
};

export const loadCropper = async () => {
  const { default: Cropper } = await import(
    /* webpackChunkName: "cropperjs" */ '@aha-app/cropperjs'
  );
  return Cropper;
};

export const loadCSMeetingScheduler = async () => {
  const { default: CSMeetingScheduler } = await import(
    /* webpackChunkName: "cs-meeting-scheduler" */ 'components/cs_meeting_scheduler/CSMeetingScheduler'
  );
  return CSMeetingScheduler;
};

export const loadStudyCalendar = async () => {
  const { default: loadStudyCalendar } = await import(
    /* webpackChunkName: "discovery-study-calendar" */ 'components/Discovery/StudyCalendar/StudyCalendar'
  );
  return loadStudyCalendar;
};

export const loadDocument = async () => {
  const { default: Document } = await import(
    /* webpackChunkName: "document" */ 'components/create_homepage/components/Document/Document'
  );
  return Document;
};

export const loadVolumeChart = async () => {
  const { default: VolumeChart } = await import(
    /* webpackChunkName: "volume-chart" */ 'components/common/VolumeChart'
  );
  return VolumeChart;
};

const loadEmojiComponents = async () => {
  const { ReactionBar, EmojiReactionPicker } = await import(
    /* webpackChunkName: "emoji-components" */ 'components/reaction_bar'
  );
  return { ReactionBar, EmojiReactionPicker };
};

export const loadReactionBar = async () => {
  const { ReactionBar } = await loadEmojiComponents();
  return ReactionBar;
};

export const loadEmojiReactionPicker = async () => {
  const { EmojiReactionPicker } = await loadEmojiComponents();
  return EmojiReactionPicker;
};

export const loadPageEmoji = async () => {
  const { default: PageEmoji } = await import(
    /* webpackChunkName: "emoji-components" */ 'components/page_icon_picker/PageEmoji'
  );
  return PageEmoji;
};

export const loadPageTemplateModal = async () => {
  const { default: PageTemplateModal } = await import(
    /* webpackChunkName: "page-template-modal" */ 'components/page_templates/PageTemplateModal'
  );
  return PageTemplateModal;
};

export const loadPoll = async () => {
  const { default: Poll } = await import(
    /* webpackChunkName: "poll" */ 'components/Polls/Poll'
  );
  return Poll;
};

export const loadEquationDefinition = async () => {
  const { default: EquationDefinition } = await import(
    /* webpackChunkName: "equation-definition" */ 'components/equation_definition/EquationDefinition'
  );
  return EquationDefinition;
};

export const loadEquationEditor = async () => {
  const { default: EquationEditor } = await import(
    /* webpackChunkName: "equation-definition" */ 'components/EquationEditor/EquationEditor'
  );
  return EquationEditor;
};

export const loadEquationInput = async () => {
  const { default: EquationInput } = await import(
    /* webpackChunkName: "equation-input" */ 'components/equation_input/EquationInput'
  );
  return EquationInput;
};

export const loadExtensionSettings = async () => {
  const { default: ExtensionSettings } = await import(
    /* webpackChunkName: "extension-settings" */ 'components/ExtensionSettings/ExtensionSettings'
  );
  return ExtensionSettings;
};

export const loadGanttRoadmap = async () => {
  const { default: GanttRoadmap } = await import(
    /* webpackChunkName: "gantt-roadmap" */ 'components/gantt_roadmap/GanttRoadmap'
  );
  return GanttRoadmap;
};

export const loadSetupWizard = async () => {
  const { default: SetupWizard } = await import(
    /* webpackChunkName: "setup-wizard" */ 'components/SetupWizard/SetupWizard'
  );
  return SetupWizard;
};

export const loadIntegrationLogs = async () => {
  const { default: IntegrationLogs } = await import(
    /* webpackChunkName: "integration-logs" */ 'components/integration_logs'
  );
  return IntegrationLogs;
};

export const loadIntegrationMapper = async () => {
  const { default: IntegrationMapper } = await import(
    /* webpackChunkName: "integration-mapper" */ 'components/integration_mapper'
  );
  return IntegrationMapper;
};

export const loadLinkedStrategicModelsPopover = async () => {
  const { LinkedStrategicModelsPopover } = await loadStrategicTemplates();
  return LinkedStrategicModelsPopover;
};

export const loadModalColumns = async () => {
  const { default: ModalColumns } = await import(
    /* webpackChunkName: "modal-columns" */ 'components/bookmarks/modal_columns/ModalColumns'
  );
  return ModalColumns;
};

export const loadModalFilter = async () => {
  const { default: ModalFilter } = await import(
    /* webpackChunkName: "modal-filter" */ 'components/bookmarks/modal_filter/ModalFilter'
  );
  return ModalFilter;
};

export const loadMonet = async () => {
  const { default: Monet } = await import(
    /* webpackChunkName: "monet" */ 'components/monet_editor'
  );

  return Monet;
};

export const loadNotebookViewer = async () => {
  const { default: NotebookViewer } = await import(
    /* webpackChunkName: "notebook-viewer" */ 'components/notebook_viewer/NotebookViewer/index'
  );
  return NotebookViewer;
};

export const loadMomentTimezone = async () => {
  const { default: moment } = await import(
    /* webpackChunkName: "moment-timezone" */ 'moment-timezone'
  );
  return moment;
};

export const loadObjectInspector = async () => {
  const { default: ObjectInspector } = await import(
    /* webpackChunkName: "react-inspector" */ 'react-inspector'
  );
  return ObjectInspector;
};

export const loadProductValueScoreCard = async () => {
  const { default: ProductValueScoreCard } = await import(
    /* webpackChunkName: "product-value-score-card" */ 'components/ProductValueScore/ProductValueScoreCard'
  );
  return ProductValueScoreCard;
};

export const loadProductValueChart = async () => {
  const { default: ProductValueChart } = await import(
    /* webpackChunkName: "product-value-chart" */ 'components/ProductValueChart/index'
  );
  return ProductValueChart;
};

export const loadProjectScoreCards = async () => {
  const { default: ProjectScoreCards } = await import(
    /* webpackChunkName: "project-score-cards" */ 'components/Settings/ProjectScoreCards'
  );
  return ProjectScoreCards;
};

export const loadDeliveryRisksChart = async () => {
  const { default: DeliveryRisksChart } = await import(
    /* webpackChunkName: "delivery-risks-chart" */ 'components/DeliveryRisksChart/index'
  );
  return DeliveryRisksChart;
};

export const loadProjectPermissions = async () => {
  const { default: ProjectPermissions } = await import(
    /* webpackChunkName: "project-permissions" */ 'components/user_permissions'
  );
  return ProjectPermissions;
};

export const loadPublishedFilterContainer = async () => {
  const { default: PublishedFilterContainer } = await import(
    /* webpackChunkName: "filter-container" */ 'components/bookmarks/published_filter_container/PublishedFilterContainer'
  );
  return PublishedFilterContainer;
};

export const loadReportActions = async () => {
  const { default: ReportActions } = await import(
    /* webpackChunkName: "report-actions" */ 'components/report_dashboard/components/external/ActionsMenu'
  );
  return ReportActions;
};

export const loadReportDashboard = async () => {
  const { default: ReportDashboard } = await import(
    /* webpackChunkName: "report-dashboard" */ 'components/report_dashboard/ReportDashboard'
  );
  return ReportDashboard;
};

export const loadReportWizard = async () => {
  const { default: ReportWizard } = await import(
    /* webpackChunkName: "report-wizard" */ 'components/bookmarks/report_wizard/ReportWizard'
  );
  return ReportWizard;
};

export const loadWorkflowCreator = async () => {
  const { default: WorkflowCreator } = await import(
    /* webpackChunkName: "workflow-creator" */ 'components/workflows/WorkflowCreator'
  );
  return WorkflowCreator;
};

export const loadReleaseTemplateCreator = async () => {
  const { default: ReleaseTemplateCreator } = await import(
    /* webpackChunkName: "release-template-creator" */ 'components/release_templates/ReleaseTemplateCreator'
  );
  return ReleaseTemplateCreator;
};

export const loadSeatManager = async () => {
  const { default: SeatManager } = await import(
    /* webpackChunkName: "seat-manager" */ 'components/seat_manager'
  );
  return SeatManager;
};

export const loadUsageCreditManager = async () => {
  const { default: UsageCreditManager } = await import(
    /* webpackChunkName: "usage-credit-manager" */ 'components/usage_credit_manager/UsageCreditManager'
  );
  return UsageCreditManager;
};

export const loadScreenDefinitionEditor = async () => {
  const { default: ScreenDefinitionEditor } = await import(
    /* webpackChunkName: "screen-definition-editor" */ 'components/ScreenDefinitions/ScreenDefinitionEditor'
  );
  return ScreenDefinitionEditor;
};

export const loadSchedulableChangeEditor = async () => {
  const { default: SchedulableChangeEditor } = await import(
    /* webpackChunkName: "schedulable-change-editor" */ 'components/Scheduling/SchedulableChangeEditor'
  );
  return SchedulableChangeEditor;
};

export const loadScoringSystemMetricBuilder = async () => {
  const { default: ScoringSystemMetricBuilder } = await import(
    /* webpackChunkName: "scoring-system-metric-builder" */ 'components/ScoringSystemMetricBuilder'
  );
  return ScoringSystemMetricBuilder;
};

export const loadSharePagePopup = async () => {
  const { default: SharePagePopup } = await import(
    /* webpackChunkName: "share-page-popup" */ 'components/SharePagePopup'
  );
  return SharePagePopup;
};

export const loadDefaultScreenDefinitionSelector = async () => {
  const { default: DefaultScreenDefinitionSelector } = await import(
    /* webpackChunkName: "screen-definition-selector" */ 'components/ScreenDefinitions/DefaultScreenDefinitionSelector'
  );
  return DefaultScreenDefinitionSelector;
};

export const loadIdeasPortalCreator = async () => {
  const { default: IdeasPortalCreator } = await import(
    /* webpackChunkName: "ideas-portal-creator" */ 'components/ideas_portals/IdeasPortalCreator'
  );
  return IdeasPortalCreator;
};

export const loadKnowledgeBaseCreator = async () => {
  const { default: KnowledgeBaseCreator } = await import(
    /* webpackChunkName: "knowledge-base-creator" */ 'components/KnowledgeBaseCreator/KnowledgeBaseCreator'
  );
  return KnowledgeBaseCreator;
};

export const loadIdeaPortalIdentityProviderCreator = async () => {
  const { default: IdeaPortalIdentityProviderCreator } = await import(
    /* webpackChunkName: "idea-portal-identity-provider-creator" */ 'components/IdeaPortalIdentityProviderCreator'
  );
  return IdeaPortalIdentityProviderCreator;
};

export const loadIdeaPortalSectionBookmarkPicker = async () => {
  const { default: BookmarkPicker } = await import(
    /* webpackChunkName: "ideas-portal-section-bookmark-picker" */ 'components/idea_portal_sections/BookmarkPicker'
  );
  return BookmarkPicker;
};

export const loadIdeaPortalSectionPagePicker = async () => {
  const { default: PagePicker } = await import(
    /* webpackChunkName: "ideas-portal-section-page-picker" */ 'components/idea_portal_sections/PagePicker'
  );
  return PagePicker;
};

export const loadStrategicModelTemplatePicker = async () => {
  const { StrategicModelTemplatePicker } = await loadStrategicTemplates();
  return StrategicModelTemplatePicker;
};

const loadStrategicTemplates = () => {
  return import(
    /* webpackChunkName: "strategic-model-templates" */ 'components/strategic_model_templates'
  );
};

export const loadTransitionAutomation = async () => {
  const { default: TransitionAutomation } = await import(
    /* webpackChunkName: "transition-automation" */ 'components/TransitionAutomation/TransitionAutomation'
  );
  return TransitionAutomation;
};

export const loadUniversalImporter = async () => {
  const { default: UniversalImporter } = await import(
    /* webpackChunkName: "universal-importer" */ 'components/universal_importer/UniversalImporter'
  );
  return UniversalImporter;
};

export const loadUniversalImporterErrors = async () => {
  const { default: UniversalImporterErrors } = await import(
    /* webpackChunkName: "universal-importer-errors" */ 'components/universal_importer/components/DisplayErrors'
  );
  return UniversalImporterErrors;
};

export const loadUserStoryMap = async () => {
  const { default: UserStoryMap } = await import(
    /* webpackChunkName: "user-story-map" */ 'components/UserStoryMap/UserStoryMap'
  );
  return UserStoryMap;
};

export const loadAddFilterButton = async () => {
  const { default: AddFilterButton } = await import(
    /* webpackChunkName: "add-filter-button" */ 'components/bookmarks/add_filter_button/AddFilterButton'
  );
  return AddFilterButton;
};

export const loadPagesSidebar = async () => {
  const { default: PagesSidebar } = await import(
    /* webpackChunkName: "pages-sidebar" */ 'components/page_tree/PagesSidebar'
  );
  return PagesSidebar;
};

export const loadWhiteboardContainer = async () => {
  const { default: WhiteboardContainer } = await import(
    /* webpackChunkName: "whiteboards" */ 'components/whiteboards/WhiteboardContainer'
  );
  return WhiteboardContainer;
};

export const loadHTMLWhiteboard = async () => {
  const { default: HTMLWhiteboard } = await import(
    /* webpackChunkName: "whiteboards" */ 'components/whiteboards/HTMLWhiteboard'
  );
  return HTMLWhiteboard;
};

export const loadWhiteboard = async () => {
  const { default: Whiteboard } = await import(
    /* webpackChunkName: "whiteboards" */ 'components/whiteboards/Whiteboard'
  );
  return Whiteboard;
};

export const loadValidateAIResponse = async () => {
  const { validateAIResponse } = await import(
    /* webpackChunkName: "whiteboards" */ 'components/whiteboards/Whiteboard'
  );
  return validateAIResponse;
};

export const loadWhiteboardContentEditor = async () => {
  const { default: WhiteboardContentEditor } = await import(
    /* webpackChunkName: "document-template-whiteboard" */ 'components/admin/WhiteboardContentEditor'
  );
  return WhiteboardContentEditor;
};

export const loadWhiteboardLandingPageTemplateGrid = async () => {
  const { default: WhiteboardLandingPageTemplateGrid } = await import(
    /* webpackChunkName: "whiteboard-landing-page-template-grid" */ 'components/whiteboards/landing_page/WhiteboardLandingPageTemplateGrid'
  );
  return WhiteboardLandingPageTemplateGrid;
};

export const loadPageIconPicker = async () => {
  const { default: PageIconPicker } = await import(
    /* webpackChunkName: "page-icon-picker" */ 'components/page_icon_picker/PageIconPicker'
  );
  return PageIconPicker;
};

export const loadDashboards = async () => {
  const { default: Dashboards } = await import(
    /* webpackChunkName: "dashboards" */ 'components/Dashboards/Dashboards'
  );
  return Dashboards;
};

export const loadDashboardFilters = async () => {
  const { default: DashboardFilters } = await import(
    /* webpackChunkName: "dashboard-filters" */ 'components/Dashboards/Filters'
  );
  return DashboardFilters;
};

export const loadWorkflowBoard = async () => {
  const { default: WorkflowBoard } = await import(
    /* webpackChunkName: "workflow-board" */ 'components/workflow_board/WorkflowBoard'
  );
  return WorkflowBoard;
};

export const loadIterationPlanner = async () => {
  const { default: IterationPlanner } = await import(
    /* webpackChunkName: "iteration-planner" */ 'components/iteration_planner/IterationPlanner'
  );
  return IterationPlanner;
};

export const loadBacklogManager = async () => {
  const { default: BacklogManager } = await import(
    /* webpackChunkName: "backlog-manager" */ 'components/backlog_manager'
  );
  return BacklogManager;
};

export const loadZendeskChat = async () => {
  const { default: ZendeskChat } = await import(
    /* webpackChunkName: "zendesk-chat" */ 'components/ZendeskChat/ZendeskChat'
  );
  return ZendeskChat;
};

export const loadFeedbackCampaignURLs = async () => {
  const { default: FeedbackCampaignURLs } = await import(
    /* webpackChunkName: "feedback-campaign-urls" */ 'components/feedback_campaigns/FeedbackCampaignURLs'
  );
  return FeedbackCampaignURLs;
};

export const loadFeedbackCampaignJWTFormField = async () => {
  const { default: FeedbackCampaignJWTFormField } = await import(
    /* webpackChunkName: "feedback-campaign-jwt-form-field" */ 'components/feedback_campaigns/FeedbackCampaignJWTFormField'
  );
  return FeedbackCampaignJWTFormField;
};

export const loadCustomPivotChart = async () => {
  const { default: CustomPivotChart } = await import(
    /* webpackChunkName: "custom-pivot-chart" */ 'components/custom_pivot_chart/CustomPivotChart'
  );
  return CustomPivotChart;
};

export const loadChartConverter = async () => {
  const { default: ChartConverter } = await import(
    /* webpackChunkName: "custom-chart-converter" */ 'components/custom_pivot_chart/ChartConverter'
  );
  return ChartConverter;
};

export const loadIdeaStatusChart = async () => {
  const { default: IdeaStatusChart } = await import(
    /* webpackChunkName: "idea-overview-status-chart" */ 'components/IdeaOverviewCharts/StatusChart'
  );
  return IdeaStatusChart;
};

export const loadIdeaOrganizationsEngagementChart = async () => {
  const { default: IdeaOrganizationsEngagementChart } = await import(
    /* webpackChunkName: "idea-organizations-engagement-chart" */ 'components/IdeaOrganizationCharts/EngagementChart'
  );
  return IdeaOrganizationsEngagementChart;
};

export const loadIdeaVolumeChart = async () => {
  const { default: IdeaVolumeChart } = await import(
    /* webpackChunkName: "idea-overview-volume-chart" */ 'components/IdeaOverviewCharts/VolumeChart'
  );
  return IdeaVolumeChart;
};

export const loadIdeaVoteHistoryChart = async () => {
  const { default: IdeaVoteHistoryChart } = await import(
    /* webpackChunkName: "idea-vote-history-chart" */ 'components/IdeaVoteHistoryChart'
  );
  return IdeaVoteHistoryChart;
};

export const loadIdeaOrganizationsStatusChart = async () => {
  const { default: IdeaOrganizationsStatusChart } = await import(
    /* webpackChunkName: "idea-organizations-status-chart" */ 'components/IdeaOrganizationCharts/StatusChart'
  );
  return IdeaOrganizationsStatusChart;
};

export const loadOpportunityValueByIdeaStageChart = async () => {
  const { default: OpportunityValueByIdeaStageChart } = await import(
    /* webpackChunkName: "opportunity-value-by-idea-stage-chart" */ 'components/OpportunityReportCharts/OpportunityValueByIdeaStageChart'
  );
  return OpportunityValueByIdeaStageChart;
};

export const loadIdeasByOpportunityValueChart = async () => {
  const { default: IdeasByOpportunityValueChart } = await import(
    /* webpackChunkName: "ideas-by-opportunity-value-chart" */ 'components/OpportunityReportCharts/IdeasByOpportunityValueChart'
  );
  return IdeasByOpportunityValueChart;
};

export const loadIdeaPromoter = async () => {
  const { default: IdeaPromoter } = await import(
    /* webpackChunkName: "idea-promoter" */ 'components/Ideas/IdeaPromoter'
  );
  return IdeaPromoter;
};

export const loadRecordPreviews = async () => {
  const { default: RecordPreviews } = await import(
    /* webpackChunkName: "record-previews" */ 'components/RecordPreviews/index'
  );
  return RecordPreviews;
};

export const loadRecordPreviewControls = async () => {
  const { default: RecordPreviewControls } = await import(
    /* webpackChunkName: "record-preview-controls" */ 'components/RecordPreviewControls/index'
  );
  return RecordPreviewControls;
};

export const loadBookmarkAuditsSidebar = async () => {
  const { default: BookmarkAuditsSidebar } = await import(
    /* webpackChunkName: "bookmark-audit-sidebar" */ 'components/bookmark_audits_sidebar/BookmarkAuditsSidebar'
  );
  return BookmarkAuditsSidebar;
};
export const loadTimelineAuditsSidebar = async () => {
  const { default: TimelineAuditsSidebar } = await import(
    /* webpackChunkName: "timeline-audit-sidebar" */ 'components/timeline_audits_sidebar/TimelineAuditsSidebar'
  );
  return TimelineAuditsSidebar;
};
export const loadSharedFilterControls = async () => {
  const { default: SharedFilterControls } = await import(
    /* webpackChunkName: "shared-filter-controls" */ 'components/SharedFilterControls/index'
  );
  return SharedFilterControls;
};
export const loadSharedBrandingControls = async () => {
  const { default: SharedBrandingControls } = await import(
    /* webpackChunkName: "shared-branding-controls" */ 'components/SharedBrandingControls/index'
  );
  return SharedBrandingControls;
};

export const loadIterationBurndown = async () => {
  const { default: IterationBurndown } = await import(
    /* webpackChunkName: "iteration-burndown" */ 'components/IterationBurndown/index'
  );
  return IterationBurndown;
};

export const loadIterationBurnup = async () => {
  const { default: IterationBurnup } = await import(
    /* webpackChunkName: "iteration-burnup" */ 'components/IterationBurnup/index'
  );
  return IterationBurnup;
};

export const loadHeatmapChart = async () => {
  const { default: HeatmapChart } = await import(
    /* webpackChunkName: "heatmap-chart" */ 'components/HeatmapChart/index'
  );
  return HeatmapChart;
};

export const loadVelocityChart = async () => {
  const { default: VelocityChart } = await import(
    /* webpackChunkName: "velocity-chart" */ 'components/VelocityChart/index'
  );
  return VelocityChart;
};

export const loadThroughputChart = async () => {
  const { default: ThroughputChart } = await import(
    /* webpackChunkName: "throughput-chart" */ 'components/ThroughputChart/index'
  );
  return ThroughputChart;
};

export const loadCycleTimeChart = async () => {
  const { default: CycleTimeChart } = await import(
    /* webpackChunkName: "cycle-time-chart" */ 'components/CycleTimeChart/index'
  );
  return CycleTimeChart;
};

export const loadPriorityList = async () => {
  const { default: PriorityList } = await import(
    /* webpackChunkName: "priority-list" */ 'components/priority_list/PriorityList'
  );
  return PriorityList;
};

export const loadStatusAutomation = async () => {
  const { default: StatusAutomation } = await import(
    /* webpackChunkName: "status-automation" */ 'components/StatusAutomation/index'
  );
  return StatusAutomation;
};

export const loadProgramIncrementIterations = async () => {
  const { default: ProgramIncrementIterations } = await import(
    /* webpackChunkName: "status-automation" */ 'components/ProgramIncrementIterations/index'
  );
  return ProgramIncrementIterations;
};

export const loadInviteTrialUsers = async () => {
  const { default: InviteTrialUsers } = await import(
    /* webpackChunkName: "invite-trial-users" */ 'components/getting_started/InviteTrialUsers'
  );
  return InviteTrialUsers;
};

export const loadDevelopCapacityGuideModal = async () => {
  const { default: DevelopCapacityGuideModal } = await import(
    /* webpackChunkName: "develop-capacity-guide-modal" */ 'components/modals/DevelopCapacityGuideModal'
  );
  return DevelopCapacityGuideModal;
};

export const loadProgramBoard = async () => {
  const { default: ProgramBoard } = await import(
    /* webpackChunkName: "program-board" */ 'components/ProgramBoard/index'
  );
  return ProgramBoard;
};

export const loadRerankReleaseCustomFields = async () => {
  const { default: ProgramBoard } = await import(
    /* webpackChunkName: "rerank-release-custom-fields" */ 'components/FeatureBoard/components/RerankReleaseCustomFields'
  );
  return ProgramBoard;
};

export const loadRetrospectiveReport = async () => {
  const { default: RetrospectiveReport } = await import(
    /* webpackChunkName: "retrospective-report" */ 'components/retrospective_report/RetrospectiveReport'
  );
  return RetrospectiveReport;
};

export const loadPublishReleaseBurndown = async () => {
  const { default: PublishReleaseBurndown } = await import(
    /* webpackChunkName: "retrospective-report" */ 'components/retrospective_report/PublishReleaseBurndown'
  );
  return PublishReleaseBurndown;
};

export const loadNavigationPicker = async () => {
  const { default: NavigationPicker } = await import(
    /* webpackChunkName: "retrospective-report" */ 'components/retrospective_report/NavigationPicker'
  );
  return NavigationPicker;
};

export const loadSettingsMenu = async () => {
  const { default: SettingsMenu } = await import(
    /* webpackChunkName: "settings_menu" */ 'components/settings_menu/index'
  );
  return SettingsMenu;
};

export const loadSlackActivityFilters = async () => {
  const { default: SlackActivityFilters } = await import(
    /* webpackChunkName: "slack-event-filter" */ 'components/integrations/slack/SlackActivityFilters'
  );
  return SlackActivityFilters;
};

export const loadDefaultViewsSettings = async () => {
  const { default: DefaultViewsSettings } = await import(
    /* webpackChunkName: "default_views_settings" */ 'components/settings_menu/DefaultViews'
  );
  return DefaultViewsSettings;
};

export const loadCreateSettingsMenu = async () => {
  const { default: CreateSettingsMenu } = await import(
    /* webpackChunkName: "create_settings_menu" */ 'components/create_homepage/components/CreateSettingsMenu'
  );
  return CreateSettingsMenu;
};

export const loadWhiteboardsWelcome = async () => {
  const { default: WhiteboardsWelcome } = await import(
    /* webpackChunkName: "notebooks_welcome" */ 'components/whiteboards_welcome/index'
  );
  return WhiteboardsWelcome;
};

export const loadSharedRecordsUserFilter = async () => {
  const { default: SharedRecordsUserFilter } = await import(
    /* webpackChunkName: "shared_records_user_filter" */ 'components/selectro/shared_records_user_filter'
  );
  return SharedRecordsUserFilter;
};

export const loadCircleChart = async () => {
  const { default: CircleChart } = await import(
    /* webpackChunkName: "circle-chart" */ 'components/common/CircleChart'
  );
  return CircleChart;
};

export const loadProductValueReportChart = async () => {
  const { default: ProductValueChart } = await import(
    /* webpackChunkName: "product-value-report-chart" */ 'components/ProductValueReportChart/index'
  );
  return ProductValueChart;
};

export const loadProductValueReport = async () => {
  const { default: ProductValueReport } = await import(
    /* webpackChunkName: "product-value-report" */ 'components/ProductValueReport/index'
  );
  return ProductValueReport;
};

export const loadDeliveryPhaseCharts = async () => {
  const { default: DeliveryPhaseCharts } = await import(
    /* webpackChunkName: "product-value-report" */ 'components/ProductValueReportChart/DeliveryPhaseCharts'
  );
  return DeliveryPhaseCharts;
};

export const loadPasswordValidation = async () => {
  const { default: passwordValidation } = await import(
    /* webpackChunkName: "password_validation" */ 'javascripts/external_app/password_validation'
  );
  return passwordValidation;
};

export const loadNowNextLaterRoadmap = async () => {
  const { default: NowNextLaterRoadmap } = await import(
    /* webpackChunkName: "now-next-later-roadmap" */ 'components/now_next_later_roadmap/NowNextLaterRoadmap'
  );
  return NowNextLaterRoadmap;
};

export const loadNowNextLaterRoadmapWizard = async () => {
  const { default: NowNextLaterRoadmapWizard } = await import(
    /* webpackChunkName: "now-next-later-roadmap-wizard" */ 'components/now_next_later_wizard/NowNextLaterRoadmapWizard'
  );
  return NowNextLaterRoadmapWizard;
};

export const loadKbSearchContainer = async () => {
  const { default: KbSearchContainer } = await import(
    /* webpackChunkName: "kb_search" */ 'components/kb_search/KbSearchContainer'
  );
  return KbSearchContainer;
};

export const loadKnowledgeBaseNavigation = async () => {
  const { default: KnowledgeBaseNavigation } = await import(
    /* webpackChunkName: "knowledge_base_navigation" */ 'components/KnowledgeBaseNavigation/KnowledgeBaseNavigation'
  );
  return KnowledgeBaseNavigation;
};

export const loadKnowledgeBaseIconPicker = async () => {
  const { default: KnowledgeBaseIconPicker } = await import(
    /* webpackChunkName: "knowledge_base_icon_picker" */ 'components/KnowledgeBaseIconPicker/KnowledgeBaseIconPicker'
  );
  return KnowledgeBaseIconPicker;
};

export const loadPersona = async () => {
  const { default: Persona } = await import(
    /* webpackChunkName: "personas_and_competitors" */ 'components/persona/Persona'
  );
  return Persona;
};
export const loadCompetitor = async () => {
  const { default: Competitor } = await import(
    /* webpackChunkName: "personas_and_competitors" */ 'components/competitor/Competitor'
  );
  return Competitor;
};

export const loadPdlcAddTemplate = async () => {
  const { default: PdlcAddTemplate } = await import(
    /* webpackChunkName: "pdlc-add-template" */ 'components/PdlcFramework/AddTemplate'
  );
  return PdlcAddTemplate;
};

export const loadKnowledgeWelcome = async () => {
  const { default: KnowledgeWelcome } = await import(
    /* webpackChunkName: "knowledge_welcome" */ 'components/knowledge_welcome/index'
  );
  return KnowledgeWelcome;
};

export const loadRestrictedDocumentsUserSelectro = async () => {
  const { default: RestrictedDocumentsUserSelectro } = await import(
    /* webpackChunkName: "restricted_documents_user_selectro" */ 'components/selectro/RestrictedDocumentsUserSelectro'
  );
  return RestrictedDocumentsUserSelectro;
};

export const loadQuoteForm = async () => {
  const { default: QuoteForm } = await import(
    /* webpackChunkName: "quote-form" */ 'components/admin/QuoteForm'
  );
  return QuoteForm;
};

export const loadFilterPopup = async () => {
  const { default: FilterPopup } = await import(
    /* webpackChunkName: "filter-popup" */ 'components/bookmarks/filter_popup/FilterPopup'
  );
  return FilterPopup;
};

export const loadShareMenu = async () => {
  const { default: ShareMenu } = await import(
    /* webpackChunkName: "share-menu" */ 'components/bookmarks/share_menu/ShareMenu'
  );
  return ShareMenu;
};

export const loadKnowledgeBaseAiChat = async () => {
  const { default: KnowledgeBaseAiChat } = await import(
    /* webpackChunkName: "knowledge_base_ai_chat" */ 'components/KnowledgeBaseAiChat/KnowledgeBaseAiChat'
  );
  return KnowledgeBaseAiChat;
};

export const loadCumulativeFlowDiagram = async () => {
  const { default: CumulativeFlowDiagram } = await import(
    /* webpackChunkName: "cumulative-flow-diagram" */ 'components/CumulativeFlowDiagram/index'
  );
  return CumulativeFlowDiagram;
};

export const loadResearchItems = async () => {
  const { default: ResearchItems } = await import(
    /* webpackChunkName: "research_item" */ 'components/Discovery/ResearchItems/ResearchItems'
  );
  return ResearchItems;
};

export const loadInterviewTranscript = async () => {
  const { default: InterviewTranscript } = await import(
    /* webpackChunkName: "interview_transcript" */ 'components/Discovery/InterviewTranscript/InterviewTranscript'
  );
  return InterviewTranscript;
};

export const loadInterviewTranscriptViewer = async () => {
  const { default: InterviewTranscriptViewer } = await import(
    /* webpackChunkName: "interview_transcript_viewer" */ 'components/Discovery/InterviewTranscriptViewer/InterviewTranscriptViewer'
  );
  return InterviewTranscriptViewer;
};

export const loadFileDescription = async () => {
  const { default: FileDescription } = await import(
    /* webpackChunkName: "file_description" */ 'components/Discovery/FileDescription/FileDescription'
  );
  return FileDescription;
};

export const loadStudyScheduler = async () => {
  const { default: StudyScheduler } = await import(
    /* webpackChunkName: "study_scheduler" */ 'components/Discovery/StudyScheduler/StudyScheduler'
  );
  return StudyScheduler;
};

export const loadDiscoveryCalendar = async () => {
  const { default: Calendar } = await import(
    /* webpackChunkName: "discoverycalendar" */ 'components/Discovery/Calendar/Calendar'
  );
  return Calendar;
};

export const loadParticipantImporter = async () => {
  const { default: ParticipantImporter } = await import(
    /* webpackChunkName: "participant_importer" */ 'components/Discovery/ParticipantImporter/ParticipantImporter'
  );
  return ParticipantImporter;
};

export const loadEmailEditor = async () => {
  const { default: EmailEditor } = await import(
    /* webpackChunkName: "email-editor" */ 'components/Discovery/EmailEditor/EmailEditor'
  );
  return EmailEditor;
};

export const loadAuditsList = async () => {
  const { default: AuditsList } = await import(
    /* webpackChunkName: "audits-list" */ 'components/AuditsList/AuditsList'
  );
  return AuditsList;
};

export const loadIdeaBoard = async () => {
  const { default: IdeaBoard } = await import(
    /* webpackChunkName: "idea-board" */ 'components/IdeaBoard/IdeaBoard'
  );
  return IdeaBoard;
};

export const loadFeatureBoardV2 = async () => {
  const { default: FeatureBoardV2 } = await import(
    /* webpackChunkName: "feature-board-v2" */ 'components/FeatureBoardV2/FeatureBoardV2'
  );
  return FeatureBoardV2;
};

export const loadBillingBundleForm = async () => {
  const { default: BillingBundleForm } = await import(
    /* webpackChunkName: "billing-bundle-form" */ 'components/AhaGlobal/BillingBundleForm'
  );
  return BillingBundleForm;
};

export const loadMiroImporter = async () => {
  const { default: MiroImporter } = await import(
    /* webpackChunkName: "miro-importer" */ 'components/miro_importer/MiroImporter'
  );
  return MiroImporter;
};

export const loadNoteAuditLoader = async () => {
  const { default: NoteAuditLoader } = await import(
    /* webpackChunkName: "note-audit-loader" */ 'components/NoteAuditLoader/NoteAuditLoader'
  );
  return NoteAuditLoader;
};

export const loadAssistant = async () => {
  const { AssistantView } = await import(
    /* webpackChunkName: "assistant" */ 'components/Assistant'
  );
  return AssistantView;
};

export const loadDevelopWelcome = async () => {
  const { default: DevelopWelcome } = await import(
    /* webpackChunkName: "develop_welcome" */ 'components/develop_welcome/index'
  );
  return DevelopWelcome;
};

export const loadAgentPromptEditor = async () => {
  const { default: AgentPromptEditor } = await import(
    /* webpackChunkName: "agent-prompt-editor" */ 'components/AgentPromptEditor/AgentPromptEditor'
  );
  return AgentPromptEditor;
};

export const loadArtifactViewer = async () => {
  const { ArtifactViewer } = await import(
    /* webpackChunkName: "artifact-viewer" */ 'components/Assistant'
  );
  return ArtifactViewer;
};

export const loadPresentationEditor = async () => {
  const { default: PresentationEditor } = await import(
    /* webpackChunkName: "presentation_editor" */ 'components/Presentations/editor/PresentationEditor'
  );
  return PresentationEditor;
};

export const loadSlideThumbnail = async () => {
  const { default: SlideThumbnail } = await import(
    /* webpackChunkName: "slide_thumbnail" */ 'components/Presentations/common/SlideThumbnail'
  );
  return SlideThumbnail;
};

export const loadAiTemplatesModal = async () => {
  const { default: AiTemplatesModal } = await import(
    /* webpackChunkName: "ai_templates_modal" */ 'components/AiTemplatesModal/AiTemplatesModal'
  );
  return AiTemplatesModal;
};

export const loadRecordLinksButton = async () => {
  const { default: RecordLinksButton } = await import(
    /* webpackChunkName: "record-links-button" */ 'components/Discovery/RecordLinksButton/RecordLinksButton'
  );
  return RecordLinksButton;
};

export const loadAnnotationTagSelector = async () => {
  const { default: AnnotationTagSelector } = await import(
    /* webpackChunkName: "annotation-tag-selector" */ 'components/Discovery/HighlightsSidePanel/AnnotationTagSelector'
  );
  return AnnotationTagSelector;
};
